'use client'

import { Button } from '@vinted/web-ui'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import ApplicationButton from '../ApplicationButton'
import EmailButton from '../EmailButton'

const ContactSection = () => {
  const translate = useTranslate('business.pro_integrations.contact')
  const isProIntegrationsApplicationEnabled = useFeatureSwitch(
    'pro_integrations_application_page_enabled',
  )

  return (
    <section className="pro-integrations__contact" data-testid="pro-integrations-contact">
      <h2
        className="pro-integrations__contact-title"
        data-testid="pro-integrations-contact-title"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: translate('title') }}
      />
      <p
        className="pro-integrations__contact-description"
        data-testid="pro-integrations-contact-description"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: translate('description') }}
      />
      <div className="pro-integrations__contact-button">
        {isProIntegrationsApplicationEnabled ? (
          <ApplicationButton
            styling={Button.Styling.Filled}
            inverse
            testId="pro-integrations-contact-apply-button"
          />
        ) : (
          <EmailButton
            styling={Button.Styling.Filled}
            text={translate('action')}
            inverse
            testId="pro-integrations-contact-button"
          />
        )}
      </div>
    </section>
  )
}

export default ContactSection
